import React, { useState, useEffect } from 'react';

function NotificationSend() {
  const [message, setMessage] = useState('');
  const [notifications, setNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [responses, setResponses] = useState([]);
  const [sendLine, setSendLine] = useState(false);

  // 通知履歴を取得
  const fetchNotifications = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(`${API_URL}/api/notifications`);
      const data = await response.json();
      if (data.success) {
        setNotifications(data.notifications);
      }
    } catch (error) {
      console.error('通知履歴取得エラー:', error);
    }
  };

  // 応答状況を取得
  const fetchResponses = async (notificationId) => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(`${API_URL}/api/notifications/${notificationId}/responses`);
      const data = await response.json();
      if (data.success) {
        setResponses(data.responses);
      }
    } catch (error) {
      console.error('応答状況取得エラー:', error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

const handleSend = async (e) => {
  e.preventDefault();
  
  const confirmMessage = sendLine 
    ? '全住民にLINE通知を送信しますか？'
    : '通知を作成してURLリストを生成しますか？';
  
  if (!window.confirm(confirmMessage)) {
    return;
  }
  
  try {
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const response = await fetch(`${API_URL}/api/notifications/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        message_text: message,
        admin_id: 1,
        send_line: sendLine // 変更
      }),
    });
    
    const data = await response.json();
    
    if (data.success) {
      // LINE送信結果を表示
      let resultHtml = '';
      
      if (data.line_results) {
        const successCount = data.line_results.filter(r => r.success).length;
        const noLineIdCount = data.line_results.filter(r => !r.has_line_id).length;
        const failCount = data.line_results.filter(r => r.has_line_id && !r.success).length;
        
        resultHtml += `
          <div style="margin: 20px 0; padding: 15px; background: #e3f2fd; border-radius: 5px;">
            <h3 style="margin-top: 0;">LINE送信結果</h3>
            <p>✅ 送信成功: ${successCount}件</p>
            <p>⚠️ LINE未登録: ${noLineIdCount}件</p>
            ${failCount > 0 ? `<p>❌ 送信失敗: ${failCount}件</p>` : ''}
          </div>
        `;
        
        if (noLineIdCount > 0) {
          resultHtml += '<h4>LINE未登録の住民:</h4>';
          data.line_results.filter(r => !r.has_line_id).forEach(result => {
            resultHtml += `
              <div style="margin: 10px 0; padding: 10px; background: #fff3cd; border-radius: 5px;">
                <strong>${result.name}</strong> - LINE User IDが未登録です
              </div>
            `;
          });
        }
        
        if (failCount > 0) {
          resultHtml += '<h4>送信失敗:</h4>';
          data.line_results.filter(r => r.has_line_id && !r.success).forEach(result => {
            resultHtml += `
              <div style="margin: 10px 0; padding: 10px; background: #ffebee; border-radius: 5px;">
                <strong>${result.name}</strong><br>
                エラー: ${result.error}
              </div>
            `;
          });
        }
      }
      
      // URLリスト
      const urlListHtml = data.urls.map(u => 
        `<div style="margin: 15px 0; padding: 15px; background: #f5f5f5; border-radius: 5px;">
          <div style="font-weight: bold;">${u.name}</div>
          <div style="color: #666;">${u.phone}</div>
          ${u.line_user_id ? 
            '<div style="color: #4CAF50; font-size: 12px;">✓ LINE登録済</div>' : 
            '<div style="color: #999; font-size: 12px;">LINE未登録</div>'
          }
          <div style="color: #2196F3; margin-top: 10px; word-break: break-all;">${u.url}</div>
        </div>`
      ).join('');
      
      // モーダル表示
      const modal = document.createElement('div');
      modal.innerHTML = `
        <div style="
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        ">
          <div style="
            background: white;
            padding: 30px;
            border-radius: 10px;
            max-width: 800px;
            max-height: 80vh;
            overflow-y: auto;
            width: 90%;
          ">
            <h2 style="margin-top: 0; color: #4CAF50;">
              ${sendLine ? 'LINE送信完了' : '送信URL一覧'}
            </h2>
            ${resultHtml}
            ${!sendLine ? '<p>以下のURLをLINEまたはメールで各住民に送信してください：</p>' : '<h4>送信されたURL一覧:</h4>'}
            ${urlListHtml}
            <button onclick="this.closest('div').parentElement.remove()" style="
              margin-top: 20px;
              padding: 10px 30px;
              background: #4CAF50;
              color: white;
              border: none;
              border-radius: 5px;
              cursor: pointer;
              font-weight: bold;
            ">閉じる</button>
          </div>
        </div>
      `;
      document.body.appendChild(modal);
      
      setMessage('');
      setSendLine(false);
      fetchNotifications();
    } else {
      alert('エラー: ' + data.message);
    }
  } catch (error) {
    console.error('送信エラー:', error);
    alert('通知の送信に失敗しました');
  }
};

  const handleViewResponses = (notification) => {
    setSelectedNotification(notification);
    fetchResponses(notification.id);
  };

  const getStatusText = (status) => {
    if (!status) return '未応答';
    switch(status) {
      case 'safe': return '✅ 大丈夫です';
      case 'danger': return '⚠️ 危ないですが、まだ大丈夫です';
      case 'emergency': return '🚨 もうだめです。すぐ避難したい';
      default: return '未応答';
    }
  };

  const getStatusColor = (status) => {
    if (!status) return '#999';
    switch(status) {
      case 'safe': return '#4CAF50';
      case 'danger': return '#FF9800';
      case 'emergency': return '#f44336';
      default: return '#999';
    }
  };

  if (selectedNotification) {
    return (
      <div>
        <button
          onClick={() => setSelectedNotification(null)}
          style={{
            marginBottom: '20px',
            padding: '10px 20px',
            backgroundColor: '#999',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          ← 戻る
        </button>

        <div style={{ 
          backgroundColor: 'white', 
          padding: '30px', 
          borderRadius: '10px',
          marginBottom: '20px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <h2>応答状況</h2>
          <p><strong>送信日時:</strong> {new Date(selectedNotification.sent_at).toLocaleString('ja-JP')}</p>
          <p><strong>メッセージ:</strong> {selectedNotification.message_text}</p>
          <p><strong>応答数:</strong> {selectedNotification.response_count} / {responses.length}</p>
        </div>

        <div style={{ 
          backgroundColor: 'white', 
          borderRadius: '10px',
          overflow: 'hidden',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5' }}>
                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>氏名</th>
                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>電話番号</th>
                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>住所</th>
                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>状態</th>
                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>応答日時</th>
              </tr>
            </thead>
            <tbody>
              {responses.map((response, index) => (
                <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '15px' }}>{response.resident_name}</td>
                  <td style={{ padding: '15px' }}>{response.phone}</td>
                  <td style={{ padding: '15px' }}>{response.address}</td>
                  <td style={{ 
                    padding: '15px',
                    color: getStatusColor(response.status),
                    fontWeight: 'bold'
                  }}>
                    {getStatusText(response.status)}
                  </td>
                  <td style={{ padding: '15px' }}>
                    {response.responded_at 
                      ? new Date(response.responded_at).toLocaleString('ja-JP')
                      : '-'
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* 通知送信フォーム */}
      <div style={{ 
        backgroundColor: 'white', 
        padding: '30px', 
        borderRadius: '10px',
        marginBottom: '30px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h2>一斉通知送信</h2>
        <form onSubmit={handleSend}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
              送信メッセージ
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              placeholder="例: 台風接近のため、安全確認を行います。現在の状況をお知らせください。"
              rows="4"
              style={{ 
                width: '100%', 
                padding: '15px', 
                border: '1px solid #ddd',
                borderRadius: '5px',
                fontSize: '16px',
                boxSizing: 'border-box',
                resize: 'vertical'
              }}
            />
          </div>
          
  	  {/* Line送信オプション */}
          <div style={{ 
            marginBottom: '20px',
            padding: '15px',
            backgroundColor: '#fff3cd',
            borderRadius: '5px',
            border: '1px solid #ffc107'
          }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={sendLine}
                onChange={(e) => setSendLine(e.target.checked)}
                style={{ marginRight: '10px', width: '20px', height: '20px' }}
              />
	      <span style={{ fontWeight: 'bold' }}>
                Lineで通知を送信する（LINE登録済みの住民のみ）
              </span>
            </label>
            <p style={{ margin: '10px 0 0 30px', fontSize: '14px', color: '#666' }}>
              チェックしない場合は、URLリストのみ生成されます
            </p>
          </div>

          <button
            type="submit"
            style={{
              padding: '15px 40px',
              backgroundColor: sendLine ? '#06C755' : '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '18px'
            }}
          >
	    {sendLine ? 'LINEで送信' : 'URLリストを生成'}
          </button>
        </form>
      </div>

      {/* 通知履歴 */}
      <div>
        <h2>送信履歴</h2>
        {notifications.length === 0 ? (
          <div style={{ 
            backgroundColor: 'white', 
            padding: '40px', 
            borderRadius: '10px',
            textAlign: 'center',
            color: '#999'
          }}>
            送信履歴はありません
          </div>
        ) : (
          <div style={{ 
            backgroundColor: 'white', 
            borderRadius: '10px',
            overflow: 'hidden',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>送信日時</th>
                  <th style={{ padding: '15px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>メッセージ</th>
                  <th style={{ padding: '15px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>応答数</th>
                  <th style={{ padding: '15px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>操作</th>
                </tr>
              </thead>
              <tbody>
                {notifications.map((notification) => (
                  <tr key={notification.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '15px' }}>
                      {new Date(notification.sent_at).toLocaleString('ja-JP')}
                    </td>
                    <td style={{ padding: '15px' }}>{notification.message_text}</td>
                    <td style={{ padding: '15px', textAlign: 'center' }}>{notification.response_count}</td>
                    <td style={{ padding: '15px', textAlign: 'center' }}>
                      <button
                        onClick={() => handleViewResponses(notification)}
                        style={{
                          padding: '8px 20px',
                          backgroundColor: '#2196F3',
                          color: 'white',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer'
                        }}
                      >
                        詳細
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default NotificationSend;
